import { computed } from 'vue';
import type HealthIndicatorEnum from '@/enums/HealthIndicatorEnum';
import type { HealthIndicatorDetails } from '@/models/HealthIndicatorDetails';
import type { RobotCompositionModule } from '@/models/RobotCompositionModule';
import gettext from '@/i18n/gettext';

export interface RobotModule extends RobotCompositionModule {
  healthIndicator: HealthIndicatorEnum;
  healthIndicatorDetails: HealthIndicatorDetails;
}

export type ModuleIdNameMapping = {
  id: string;
  name: string;
};

export type SampleRobotConfig = {
  name: string;
  moduleIds: string[];
  price: string;
};

export type RobotRegistration = {
  serialNumber: string;
  password: string;
  groupUuid: string | null;
};

export type UpdateRobotGroup = {
  serialNumber: string;
  groupUuid: string;
};

export enum RobotFinderType {
  SAMPLE_CONFIG = 'sampleConfig',
  CUSTOM_CONFIG = 'customConfig',
  REVERSE_CALCULATION = 'reverseCalculation',
}

const { $gettext } = gettext;
export const ROBOT_CONFIGURATION_TYPES = computed(() => [
  {
    title: $gettext('Sample configuration'),
    value: RobotFinderType.SAMPLE_CONFIG,
  },
  {
    title: $gettext('Custom Robot Configuration'),
    value: RobotFinderType.CUSTOM_CONFIG,
  },
]);

export const ROBOT_CALCULATION_TYPES = computed(() => [
  ...ROBOT_CONFIGURATION_TYPES.value,
  {
    title: $gettext('Reverse calculation'),
    value: RobotFinderType.REVERSE_CALCULATION,
  },
]);
